module.exports = __webpack_public_path__ + "Roboto-Black.893fe14628bd7ac498d5.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-Black.ttf
// module id = 379
// module chunks = 2